import _plugin_vue_export_helper_default from "../../../../_virtual/_plugin-vue_export-helper.js";
import { createElementBlock, createElementVNode, openBlock, renderSlot } from "vue";
//#region src/v2/blocks/response-block/components/ResponseBodyInfo.vue
var _sfc_main = {};
var _hoisted_1 = { class: "flex justify-center px-2 py-3" };
var _hoisted_2 = { class: "text-c-3 p-2 text-sm" };
function _sfc_render(_ctx, _cache) {
	return openBlock(), createElementBlock("div", _hoisted_1, [createElementVNode("div", _hoisted_2, [renderSlot(_ctx.$slots, "default")])]);
}
var ResponseBodyInfo_default = /*#__PURE__*/ _plugin_vue_export_helper_default(_sfc_main, [["render", _sfc_render]]);
//#endregion
export { ResponseBodyInfo_default as default };

//# sourceMappingURL=ResponseBodyInfo.vue.js.map